/*@ngInject*/
const UmRevisionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getUmVersionNumber = function () {
        let url =  '/rest/Server';

        return this.get(url);
    }
};

angular.module('umCore')
    .service('umRevisionRepository', UmRevisionRepository);
